export default [
    {
      path: '/influencers',
      name: 'Influencers',
      component: () => import(/* webpackChunkName: 'influencers' */ './views/Index.vue')
    },
  ]
  